import DISTRIBUTION from './DISTRIBUTION'
import LAB from './LAB'
import store from '../store'
export default {
  matchComponent: function (component) {
    let focusView = store.state.saasConfig.focusView
    if (!focusView) return null
    return focusView + '-' + component
  }
}
